// extracted by mini-css-extract-plugin
export default {"loadingWidget":"v1YvmPxyiCP6q5LVoM06X"};